<template>
  <div class="sidebar-wrap">
    <template v-for="item in routes" v-if="!item.hidden && item.nodes">
      <!-- 一级菜单 -->
      <el-submenu
        class="sidebar-wrap__menu"
        :key="item.name"
        :index="item.name || item.url">
        <template slot="title">
          <icon 
            v-if="item && item.icon"
            :name="item.icon"
            :scale="2">
          </icon>
          <span slot="title" v-if="item && item.name">
            {{sliderState === 'full' ? getTitle(item.name) : ''}}
          </span>
        </template>
        <template v-for="child in item.nodes" v-if="!child.hidden">
          <router-link
            :to="child.url"
            :key="child.name">
            <el-menu-item :index="child.url">
              <icon 
                v-if="child && child.icon"
                :name="child.icon"
                :scale="2">
              </icon>
              <span slot="title" v-if="child && child.name">
                {{getTitle(child.name)}}
              </span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },
  computed: {
    sliderState() {
      return this.$store.getters.sidebar.sliderState
    }
  },
  methods: {
    onlyOneShowingChildren(children) {
      return children.filter(item => !item.hidden).length === 1
    },
    getTitle(title) {
      if (this.$te(`route.${title}`)) {
        return this.$t(`route.${title}`)
      }
      return title
    }
  }
}
</script>

<style lang="stylus" scoped>
.sidebar-wrap
  .el-submenu,
  .el-menu-item
    font-size 0
    svg
      margin-right 17px
    span 
      font-size 13px
  .svg-icon
    fill currentColor
</style>
